import { render, staticRenderFns } from "./uf_place_industrial_equipment.vue?vue&type=template&id=bfa0edea&scoped=true"
import script from "./uf_place_industrial_equipment.vue?vue&type=script&lang=js"
export * from "./uf_place_industrial_equipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0edea",
  null
  
)

export default component.exports